<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Purchased: His Perfect Wife</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<div class="frontMatterPage" id="fm01"><div class="chapterHead"><p class="centerImage"><span><img alt="image" src="Images/01.jpg"/></span></p></div><div class="chapterBody"><p class="chapterOpenerText"><span>Welcome to the October 2008 collection of Harlequin Presents!</span></p><p class="paraNoIndent0"><span>This month read Sandra Marton’s <em class="italic"><span>The Sheikh’s Defiant Bride,</span></em> the first book in her exciting trilogy THE SHEIKH TYCOONS. We also visit the Mediterranean, and two affluent heroes who aren’t afraid to take what they want, in Julia James’s <em class="italic"><span>Greek Tycoon, Waitress Wife</span></em> and Robyn Donald’s <em class="italic"><span>His Majesty’s Mistress.</span></em> Things begin to heat up at work (or should we say <em class="italic"><span>after</span></em> work) for Abby in Anne Oliver’s <em class="italic"><span>Business in the Bedroom.</span></em> Maggie Cox also brings you a sexy office tale, this time involving an Italian tycoon and his unsuspecting personal assistant, in <em class="italic"><span>Secretary Mistress, Convenient Wife.</span></em> Helen Bianchin weaves a story of attraction and convenience in <em class="italic"><span>Purchased: His Perfect Wife,</span></em> in which cash-strapped Lara finds herself making a deal with her brooding stepbrother. Innocence is lost and passion abounds in <em class="italic"><span>One Night with His Virgin Mistress</span></em> by Sara Craven, and housekeeper Liv’s job description is more hands-on than most in <em class="italic"><span>Housekeeper at His Beck and Call,</span></em> compliments of Susan Stephens.</span></p><p class="paraNoIndent1"><span>We’d love to hear what you think about Harlequin Presents. E-mail us at Presents@hmb.co.uk, or join in the discussions at www.iheartpresents.com and www.sensationalromance.blogspot.com, where you’ll also find more information about books and authors!</span></p></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// purchasedhisperfectwife_fm01.vue?47e1ac4a